import React from "react";
import * as AlertDialog from "@radix-ui/react-alert-dialog";

interface CopyTradeUnsubscribeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  nickname: string;
  isLoading?: boolean;
  onConfirm: () => void;
}

export const CopyTradeUnsubscribeDialog: React.FC<
  CopyTradeUnsubscribeDialogProps
> = ({ open, onOpenChange, nickname, isLoading, onConfirm }) => {
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 bg-black/80 z-[200]" />
        <AlertDialog.Content className="fixed left-[50%] top-[50%] z-[201] max-h-[85vh] w-[90vw] max-w-[500px] translate-x-[-50%] translate-y-[-50%] rounded-lg bg-secondary border border-border p-6 shadow-lg">
          <AlertDialog.Title className="text-xl font-bold text-text-primary mb-2">
            Unsubscribe from {nickname}?
          </AlertDialog.Title>
          <AlertDialog.Description className="text-text-secondary mb-6">
            We will stop copying new positions from this trader. Any open
            positions you already have will stay open — close them manually if
            needed.
          </AlertDialog.Description>
          <div className="flex gap-3 justify-end">
            <AlertDialog.Cancel className="px-4 py-2 rounded-xl border border-border text-sm">
              Cancel
            </AlertDialog.Cancel>
            <AlertDialog.Action
              onClick={(e) => {
                e.preventDefault();
                onConfirm();
              }}
              disabled={isLoading}
              className="px-4 py-2 rounded-xl bg-red-500 text-white text-sm font-medium disabled:opacity-50"
            >
              Unsubscribe
            </AlertDialog.Action>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
};
